export default {
  minWidth: 0
}



// WEBPACK FOOTER //
// ./src/styles/buttons/link.js